import React from 'react';
import ToAccountManuallyDF from '../components/SimulatorsComponents/DefualtSimulators/ToAccountManuallyDF';
//= ========================================================================

const Sim_B06_SendMoneyToAccountManually = ({
  globJSON,
  selectedScreen,
  language,
  simPlatform,
  slideshowRefs = null,
}) => (
  <ToAccountManuallyDF
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    language={language}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
  />
);

export default Sim_B06_SendMoneyToAccountManually;
